import CustomizeVariant from './CustomizeVariant/CustomizeVariant';

export { CustomizeVariant };

export const STATION_STATUS = {
    AVAILABLE: 'Available',
    CHARGING: 'Charging',
    UNAVAILABLE: 'Unavailable',
};

export const CONNECTOR_STATUS = {
    AVAILABLE: 'Available',
    PREPARING: 'Preparing',
    CHARGING: 'Charging',
    SUSPENDED_EV: 'SuspendedEV',
    SUSPENDED_EVSE: 'SuspendedEVSE',
    FINISHING: 'Finishing',
    RESERVED: 'Reserved',
    FAULTED: 'Faulted',
    UNAVAILABLE: 'Unavailable',
};

const CONNECTOR_STATUS_MAP = {
    Available: CONNECTOR_STATUS.AVAILABLE,
    Preparing: CONNECTOR_STATUS.PREPARING,
    Charging: CONNECTOR_STATUS.CHARGING,
    SuspendedEV: CONNECTOR_STATUS.SUSPENDED_EV,
    SuspendedEVSE: CONNECTOR_STATUS.SUSPENDED_EVSE,
    Finishing: CONNECTOR_STATUS.FINISHING,
    Reserved: CONNECTOR_STATUS.RESERVED,
    Faulted: CONNECTOR_STATUS.FAULTED,
    Unavailable: CONNECTOR_STATUS.UNAVAILABLE,
};

export const mapConnectorStatus = (status) =>
    CONNECTOR_STATUS_MAP[status] || CONNECTOR_STATUS.UNAVAILABLE;

// `available` is redundant with `status` and only exists for older app builds —
// read it only when the server did not send `status`.
export const getStationStatus = (station) =>
    station?.status ||
    (station?.available ? STATION_STATUS.AVAILABLE : STATION_STATUS.UNAVAILABLE);

const CONNECTOR_STANDARD_LABELS = {
    ccs: 'CCS',
    ccs1: 'CCS1',
    ccs2: 'CCS2',
    chademo: 'CHAdeMO',
    'gb/t': 'GB/T',
    gbt: 'GB/T',
    iec60309: 'IEC60309',
    type_1: 'Type 1',
    type_2: 'Type 2',
};

// Display only. The raw API value is what goes back out in `connector_type`.
export const prettyConnectorStandard = (standard) => {
    if (!standard) return '';
    const known = CONNECTOR_STANDARD_LABELS[String(standard).toLowerCase()];
    if (known) return known;
    // Unknown standards still come from the enum endpoint, so show them rather
    // than dropping them: `some_plug` -> `Some Plug`.
    return String(standard)
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (character) => character.toUpperCase());
};
